/**
 * DOM utility: remove element from DOM.
 * Replaces belter.destroyElement().
 */
export function destroyElement(el: Element | null | undefined): void {
  if (el) el.remove();
}

/**
 * CSS utility: convert number to CSS pixel string, pass strings through.
 * Replaces belter.toCSS().
 */
export function toCSS(value: number | string): string {
  return typeof value === 'number' ? `${value}px` : value;
}
